import { render } from "./ModalFooter.vue?vue&type=template&id=235e5a9a&scoped=true"
import script from "./ModalFooter.vue?vue&type=script&lang=js"
export * from "./ModalFooter.vue?vue&type=script&lang=js"

import "./ModalFooter.vue?vue&type=style&index=0&id=235e5a9a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-235e5a9a"],['__file',"src/components/mdbvue/Modals/ModalFooter.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "235e5a9a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('235e5a9a', __exports__)) {
    api.reload('235e5a9a', __exports__)
  }
  
  module.hot.accept("./ModalFooter.vue?vue&type=template&id=235e5a9a&scoped=true", () => {
    api.rerender('235e5a9a', render)
  })

}


export default __exports__